// Filename: public/constant.js

// Code written in public files is shared by your site's
// Backend, page code, and site code environments.

// Use public files to hold utility functions that can
// be called from multiple locations in your site's code.
export const coordSets = "409b61c7-3114-4747-a472-c4e58a862a7c"
export const tops = "5701805d-4ed3-43cd-995f-f2729027b029"
export const jumpsuits = "5dc1c214-f18e-473b-883d-dd564e487f65"


export const product_jumpsuits = "8aa38788-296f-4740-945b-89975a0fbbce"
export const product_tops = "5a48d939-d182-4ebe-9bb3-ed247a333065"
export const product_coordSets = "35318b9a-9c2d-4e98-9a32-04b6264bb4d2"
// The following code demonstrates how to call the add
// function from your site's page code or site code.
/*
import {add} from 'public/constant.js'
$w.onReady(function () {
    let sum = add(6,7);
    console.log(sum);
});
*/